import dispatchFetch from "./dispatchFetch";
import shouldAutoDispatchFetch from "./shouldAutoDispatchFetch";

const fetchData = (component, isMounting = false) => {
  if(shouldAutoDispatchFetch(component, isMounting)) {
    dispatchFetch(component)
  }
};

export default fetchData;